const ApiAjax = {
    'body':'',
    'start':function(){
        let self = this;
        self.init();
    },
    'callModal': function(modalName){
        let self = this;
        //--------------------------------------------------------------------------------------------------------------
        let ajaxName = 'getModal';
        //--------------------------------------------------------------------------------------------------------------
        let formData = new FormData();
        formData.append('ajaxToken', _ajaxToken);
        formData.append('modalName', modalName);
        //--------------------------------------------------------------------------------------------------------------
        let ajaxCall = $.ajax({
            headers: {'X-CSRF-Token': _csrfToken},
            url: _ajaxRoot  + 'ajax/' + ajaxName,
            type: 'POST',
            data: formData,
            contentType: false,        // VERY IMPORTANT
            processData: false,        // VERY IMPORTANT
        });
        //--------------------------------------------------------------------------------------------------------------
        ajaxCall.done(function(response) {
            // console.log(response);
            let Modal = self.body.find('.modals');
            let ajaxResponse = response['ajax-response']??[];
            let modalHtml = ajaxResponse['modal'];
            Modal.html(modalHtml);
            Modal.removeClass('hidden');
        });

    },
    'callAutocomplete': function(fields){
        let self = this;
        //--------------------------------------------------------------------------------------------------------------
        let ajaxName = 'getAutocomplete';
        //--------------------------------------------------------------------------------------------------------------
        let formData = new FormData();
        formData.append('ajaxToken', _ajaxToken);
        formData.append('fields', fields);
        //--------------------------------------------------------------------------------------------------------------
        let ajaxCall = $.ajax({
            headers: {'X-CSRF-Token': _csrfToken},
            url: _ajaxRoot  + 'ajax/' + ajaxName,
            type: 'POST',
            data: formData,
            contentType: false,        // VERY IMPORTANT
            processData: false,        // VERY IMPORTANT
        });
        //--------------------------------------------------------------------------------------------------------------
        ajaxCall.done(function(response) {
            // console.log(response);
            let ajaxResponse = response['ajax-response']??[];
            let searchFields = ajaxResponse['searchFields']??'[]';
            ApiAutocomplete.searchFields = JSON.parse(searchFields);
            ApiAutocomplete.setAutocompleteSearches();
        });
    },
    'init':function(){
        let self = this;
        self.body = $('body');
    }
}

$(document).ready(function(){
    ApiAjax.start();
});
